<div class="section-container" id="work">
    <div class="section-left">
      <h2>{{strings.portfolio}}</h2>
    </div>

    <div class="section-right">
      <div class="work-section-wrapper">
        <div class="section-title">
          <h2 [innerHTML]="strings.workSectionTitle"></h2>
          <div class="section-subtitle">
            <p>{{strings.workSectionSubtitle}}</p>
          </div>
        </div>
        <div class="work-section-content">
          <div class="work-card" *ngFor="let project of projects">
            <a [href]="project.link" target="_blank">
              <img [src]="project.image" alt="{{project.title}} image" class="project-image" loading="lazy">
              <div class="project-title">
                <h2>{{project.title}}</h2>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
